var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 182,
    viewBox: "0 0 234 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 91.0813C53 140.742 93.258 181 142.919 181C192.579 181 232.837 140.742 232.837 91.0813C232.837 41.4205 192.579 1.16254 142.919 1.16254C93.258 1.16254 53 41.4205 53 91.0813Z",
    stroke: "black",
    strokeOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M83.1367 103C88.6122 130.929 113.223 152 142.756 152C176.311 152 203.512 124.799 203.512 91.2441C203.512 57.6896 176.311 30.4884 142.756 30.4884C119.6 30.4884 99.4693 43.4429 89.2165 62.5",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M107 90.5464C107 110.679 123.321 127 143.454 127C163.586 127 179.907 110.679 179.907 90.5464C179.907 70.4137 163.586 54.0929 143.454 54.0929C123.321 54.0929 107 70.4137 107 90.5464Z",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.58249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129 91.1976C129 98.8203 135.18 105 142.803 105C150.425 105 156.605 98.8203 156.605 91.1976C156.605 83.5746 150.425 77.3949 142.803 77.3949C135.18 77.3949 129 83.5746 129 91.1976Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5404 107.042C17.2449 105.952 16.5192 104.432 16.3634 102.484H0.817372C0.836865 106.4 1.80608 109.823 3.72502 112.755C5.64396 115.687 8.36645 117.962 11.8925 119.579C15.4186 121.195 19.5973 122.004 24.4286 122.004C29.1624 122.004 33.3557 121.205 37.0085 119.608C40.6612 118.01 43.5151 115.785 45.5704 112.931C47.6256 110.077 48.6435 106.75 48.624 102.951C48.6435 98.276 47.1289 94.5893 44.0801 91.8912C41.0313 89.1931 36.8575 87.2693 31.5586 86.1197L25.5974 84.834C22.2662 84.1134 19.9382 83.3001 18.6135 82.3942C17.2888 81.4884 16.6167 80.3536 16.5972 78.9899C16.6167 77.5093 17.2936 76.3014 18.6281 75.3663C19.9625 74.4312 21.935 73.9637 24.5454 73.9637C27.6624 73.9637 30.1024 74.6796 31.8655 76.1115C33.6285 77.5434 34.5782 79.6328 34.7146 82.3796H50.1436C50.1241 77.373 49.0477 73.2674 46.9146 70.0627C44.7814 66.8581 41.7813 64.4862 37.9143 62.9471C34.0473 61.408 29.5131 60.6384 24.3117 60.6384C16.7336 60.6384 10.7918 62.2213 6.48647 65.3869C2.18104 68.5526 0.0187165 73.0869 -0.000497965 78.9899C0.018995 83.5485 1.48973 87.3911 4.41172 90.5178C7.33399 93.6444 12.0971 95.9188 18.7011 97.341L23.6104 98.3928C26.4351 98.9968 28.505 99.7468 29.8199 100.643C31.1349 101.539 31.7534 102.698 31.6755 104.12C31.656 105.445 31.0716 106.536 29.9222 107.393C28.7728 108.25 26.9416 108.679 24.4286 108.679C21.7986 108.679 19.8359 108.133 18.5404 107.042Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232 74.4309V61.3396H179.986V74.4309H197.986V121.186H214V74.4309H232Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3389 61.3396V121.186H72.5864V103.419H81.5867C86.1452 103.419 90.1339 102.571 93.5527 100.876C96.9717 99.1815 99.631 96.7659 101.53 93.6295C103.43 90.4931 104.379 86.7819 104.379 82.496C104.379 78.2492 103.454 74.538 101.603 71.3626C99.7524 68.1872 97.1615 65.7229 93.8304 63.9696C90.4991 62.2163 86.6126 61.3396 82.171 61.3396H56.3389ZM78.3135 90.795H72.5863V74.314H78.3135C81.1578 74.314 83.3884 75.0348 85.0055 76.4764C86.6223 77.918 87.4307 79.9245 87.4307 82.496C87.4307 85.0482 86.6223 87.0693 85.0055 88.5594C83.3884 90.0498 81.1578 90.795 78.3135 90.795Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoB);
export default __webpack_public_path__ + "static/media/logo-b.e1fff167456867ff291d61d378f0d044.svg";
export { ForwardRef as ReactComponent };